import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseItemVibranceOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-vibrance-option';
import {useAppSelector} from '@/hooks';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.types';

export function VideoBgVibranceOption(): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.VIDEO) {
    return null;
  }

  const updateVibrance = (vibrance: number, undoable?: boolean): void => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          videoBackgroundItemObject: {
            effects: {
              vibrance,
            },
          },
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemVibranceOption vibrance={currentPageBackground.details.videoBackgroundItemObject.effects.vibrance} updateVibrance={updateVibrance} />;
}
